import React from "react";
import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";
import * as colors from "../../settings/colors";

const activeClassName = "tab-link-active";

const TabLink = ({ component: Component = NavLink, ...props }) => {
  if (Component === "a") {
    const { activeClassName, active, ...otherProps } = props;
    return <Component {...otherProps} />;
  } else {
    const { active, ...otherProps } = props;
    return <Component {...otherProps} />;
  }
};

//prettier-ignore
const StyledTabLink = styled(TabLink).attrs({
  activeClassName
})`
  display: flex;
  position: relative;
  align-items: center;
  color: ${colors.TAB_TEXT};
  font-size: 14px;
  font-weight: 600;
  padding: 12px 0;
  transition-property: color, background-color;
  transition-duration: .2s;
  text-decoration: none;
  margin-right: 20px;
  cursor: pointer;

  &::after {
    position: absolute;
    display: block;
    content: ' ';
    right: 0;
    bottom: -1px;
    left: 0;
    height: 1px;
    background: ${colors.TAB_ACTIVE_TEXT};
    transform: scaleX(0);
    transform-origin: 50% 50%;
    transition: transform 0.3s ease;
  }

  &:hover {
    color: ${colors.TAB_ACTIVE_TEXT};
  }

  ${props => props.active && css`
    color: ${colors.TAB_ACTIVE_TEXT};

    &:after {
      transform: scaleX(1);
    }
  `}

  &:active,
  &.${activeClassName} {
    color: ${colors.TAB_ACTIVE_TEXT};
  }

  &.${activeClassName}:after {
    transform: scaleX(1);
  }
`;

export default StyledTabLink;



// WEBPACK FOOTER //
// ./src/components/tabs/TabLink.js